var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6652 17.8629C40.4706 17.8629 44.3661 13.9674 44.3661 9.16206C44.3661 4.3567 40.4706 0.461182 35.6652 0.461182C30.8599 0.461182 26.9644 4.3567 26.9644 9.16206C26.9644 13.9674 30.8599 17.8629 35.6652 17.8629Z",
    fill: "#4BBCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6979 21.0238L36.333 82.4611L57.3575 2.26196L38.0362 26.0239L25.6979 21.0238Z",
    fill: "#4BBCFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6979 21.0238L36.333 82.4611L57.3575 2.26196L38.0362 34.769L25.6979 21.0238Z",
    fill: "#1D49EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6979 21.0238L36.333 82.4611L57.3575 2.26196L38.0362 26.0239L25.6979 21.0238Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWork);
export default __webpack_public_path__ + "static/media/myWork.0c737e80b886d274d5afa4e532fea464.svg";
export { ForwardRef as ReactComponent };